<template>
  <div class="news_wrapper">
  </div>
</template>
<script>
export default {
  name: "News"
};
</script>
<style lang="less" scoped>
div.news_wrapper {
  position: relative;
  min-width: 1420px;
  width: 100%;
  > img {
    width: 100%;
  }
}
</style>
